export const HERO_IMG = `${process.env.PUBLIC_URL || ''}/images/hero-landing.jpg`;
export const HERO_IMG_WEBP = `${process.env.PUBLIC_URL || ''}/images/hero-landing.webp`;

export const GROUP_TOPICS = [
  { icon: '✈️', title: 'Travel', desc: 'Need ideas on traveling?' },
  { icon: '🚗', title: 'Cars', desc: 'Discuss your favorite cars.' },
  { icon: '🏅', title: 'Olympics', desc: 'Discuss current Olympic games.' },
  { icon: '🆕', title: 'Fresh Groups', desc: 'Newly created by users.' },
  { icon: '⭐', title: 'Promoted', desc: 'Community promoted groups.' },
  { icon: '🎵', title: 'Music', desc: 'Meet other music enthusiasts.' },
  { icon: '😂', title: 'Meme Sharing', desc: 'Share and collect new memes.' },
  { icon: '🎌', title: 'Anime', desc: 'Anime recommendations you must watch.' },
  { icon: '🎮', title: 'Games', desc: 'Find gaming buddies.' },
  { icon: '🍕', title: 'Foodie', desc: 'Share personal recipes.' },
  { icon: '🎬', title: 'Movies', desc: 'Best movie recommendations.' },
  { icon: '🔬', title: 'Science', desc: "What's new in science." },
  { icon: '📰', title: 'News', desc: 'Discuss current events.' },
  { icon: '⚽', title: 'Sports', desc: 'Athletes & favorite teams.' },
  { icon: '💚', title: 'Wellness', desc: 'Mental health support chat.' },
];

export const LONG_FEATURES = [
  {
    icon: '📱',
    title: 'Mobile chat anywhere',
    text: 'Use Vibe Talk on Android, iPhone, desktop, or tablet. Responsive design fits any screen — chat from anywhere without downloading an app.',
  },
  {
    icon: '👩👨',
    title: 'Talk to strangers',
    text: 'Meet people from around the world online, free and anonymously. Random match, direct messages, and video calls keep conversations fresh and fun.',
  },
  {
    icon: '🔒',
    title: 'Online chat without login',
    text: 'Start as a guest with just a nickname — no sign-up required. Create a full profile later to unlock filters, DMs, and group creation.',
  },
  {
    icon: '🆓',
    title: 'Free groups & chat',
    text: 'Basic chat, random match, and groups are completely free. We use ads (Google AdSense, Monetag) to keep the service running.',
  },
  {
    icon: '💯',
    title: '100% free online chat',
    text: 'Random video chat, voice messages, and group chat are free on our platform. Talk to strangers to learn English, make friends, or simply have a cam-to-cam conversation online.',
  },
  {
    icon: '🔐',
    title: 'Private one-to-one chat',
    text: 'Direct messages give you a private chatting environment. Message users from the Users list or after Random Match — one-to-one, at your pace.',
  },
  {
    icon: '🏘️',
    title: 'Group chat (not chat rooms)',
    text: 'Join interest-based Groups or create your own. Search groups, invite friends, share media — a modern alternative to old public chat rooms.',
  },
  {
    icon: '👩',
    title: 'Talk to female strangers',
    text: 'We focus on a female-friendly, clean community. Be social and responsible — friendship and conversation, not dating or harassment.',
  },
  {
    icon: '🔄',
    title: 'Random chat & stranger meetup',
    text: 'One tap Random Match connects you with someone new. Skip with Next, or move to video when you are ready.',
  },
  {
    icon: '🅾️',
    title: 'Omegle alternative',
    text: 'Inspired by Omegle and ChatHub — random chat without captcha hassle, video calls in browser, and groups by interest. Works on mobile and VPN-friendly hosting.',
  },
];

export const SEO_INTRO =
  'Vibe Talk is a free browser-based platform for random chat, text chat, video calls, groups, and meeting new people online. Talk to strangers without login, without app download, without bots & without spam. Our random match feature connects you with people worldwide for text and video conversations. Join interest-based Groups for music, gaming, anime, travel, and more. Female-friendly, clean community focused on friendship — not dating or harassment.';

export const SEO_MORE =
  ' Whether you want to chat with strangers to learn English, practice conversation skills, make international friends, or simply have a safe webcam chat — Vibe Talk provides a free platform for genuine connections. No phone number required, no registration needed to start. Our Omegle alternative offers random video chat, direct messaging, and topic-based groups. Works on mobile, desktop, and tablet. Be social, be respectful, and enjoy meeting new people on vibetalk.me. If you search for chat with girls or chat with women online, remember that every person chooses their own boundaries and whether they want to continue a conversation.';

export const FOOTER_SEO_LINKS = [
  { to: '/start', label: 'Vibe Talk Random Chat' },
  { to: '/about#groups', label: 'Interest Groups' },
  { to: '/articles', label: 'Chat Tips & Articles' },
  { to: '/about', label: 'About Us' },
];

export const CHAT_BENEFITS = [
  'Guest chat — no registration',
  'Random match & video calls',
  'Groups by topic — not chat rooms',
  'Mobile & desktop friendly',
];
